<template>
  <div class="blog-wrapper m-5">
    <!-- ======= Testimonials Section ======= -->
    <section
      id="testimonials"
      class="testimonials"
    >
      <div
        class="container"
        data-aos="fade-up"
      >
        <div class="section-title">
          <h2>Browse Tutors</h2>
        </div>
      </div>
      <!-- input search -->
      <b-form-group class="blog-search px-3">
        <b-input-group class="input-group-merge">
          <b-form-input
            id="search-input"
            v-model="search"
            placeholder="Search here"
          />
          <b-input-group-append
            class="cursor-pointer"
            is-text
          >
            <feather-icon icon="SearchIcon" />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <!--/ input search -->
      <div
        v-if="filtredTutors == 0"
        class="d-flex justify-content-center"
      >
        No tutors found !
      </div>

      <!-- blogs -->
      <b-row class="blog-list-wrapper">
        <b-col
          v-for="tutor in filtredTutors"
          :key="tutor.photo"
          md="12"
          class="px-3"
        >
          <tutor-card :tutor="tutor" />
        </b-col>
        <b-col cols="12">
          <!-- pagination -->
          <div class="my-2">
            <b-pagination
              v-model="currentPage"
              align="center"
              :total-rows="rows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-col>
      </b-row>

    </section>
    <!--/ blogs -->
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BLink,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BButton,
} from 'bootstrap-vue'
import { kFormatter } from '@core/utils/filter'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import tutorCard from './components/tutorCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BButton,
    ContentWithSidebar,
    tutorCard,
  },
  data() {
    return {
      search: '',
      selectedTag: '',
      blogList: [],
      tutorList: [],
      blogSidebar: {},
      currentPage: 1,
      perPage: 5,
      rows: 0,
      apiUrl: process.env.VUE_APP_API_URL,
      list_skills: [],
    }
  },
  computed: {
    filtredTutors() {
      let tutors = this.tutorList
      if (this.search) {
        tutors = tutors.filter(el => (
          el.username.includes(this.search)
            || el.fullName.includes(this.search)
            || el.title.includes(this.search)
            || el.school.includes(this.search)
            || el.tags.filter(tag => tag.name.includes(this.search)).length > 0
        ))
      }
      this.rows = tutors.length
      return tutors.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage,
      )
    },
  },
  created() {
    // this.$http.get('/blog/list/data').then(res => { this.blogList = res.data })
    this.$http.get('/blog/list/data/sidebar').then(res => {
      this.blogSidebar = res.data
    })

    this.$http.get('tutor/accounts').then(res => {
      this.tutorList = res.data.tutors
    })

    this.getSkills()
  },
  methods: {
    kFormatter,
    tagsColor() {
      const colors = [
        'light-info',
        'light-danger',
        'light-primary',
        'light-secondary',
        'light-success',
      ]
      const random = Math.floor(Math.random() * colors.length)
      return 'light-info'
    },
    selectTag(tag) {
      if (tag == this.selectedTag) return (this.selectedTag = '')
      return (this.selectedTag = tag)
    },
    getSkills() {
      this.$http
        .post('skills')
        .then(res => {
          const { skills } = res.data
          this.list_skills = skills
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-blog.scss";
</style>

<style scoped>
/*--------------------------------------------------------------
# Services
--------------------------------------------------------------*/
.services .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  margin: 0;
  background: #fff;
  box-shadow: 0 10px 29px 0 rgba(68, 88, 144, 0.1);
  transition: all 0.3s ease-in-out;
  border-radius: 4px;
  text-align: center;
  border-bottom: 3px solid #fff;
}

.services .icon-box:hover {
  transform: translateY(-5px);
}

.services .icon i {
  font-size: 48px;
  line-height: 1;
  margin-bottom: 15px;
}

.services .title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

.services .title a {
  color: #111;
}

.services .description {
  font-size: 15px;
  line-height: 28px;
  margin-bottom: 0;
}

.services .icon-box-pink .icon i {
  color: #ff689b;
}

.services .icon-box-pink:hover {
  border-color: #ff689b;
}

.services .icon-box-cyan .icon i {
  color: #3fcdc7;
}

.services .icon-box-cyan:hover {
  border-color: #3fcdc7;
}

.services .icon-box-green .icon i {
  color: #41cf2e;
}

.services .icon-box-green:hover {
  border-color: #41cf2e;
}

.services .icon-box-blue .icon i {
  color: #2282ff;
}

.services .icon-box-blue:hover {
  border-color: #2282ff;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 60px 0;
  overflow: hidden;
}

.section-bg {
  background-color: #f7fbfe;
}

.section-title {
  text-align: center;
  padding-bottom: 30px;
}

.section-title h2 {
  font-size: 32px;
  font-weight: bold;
  text-transform: uppercase;
  position: relative;
  color: #222222;
}

.section-title h2::before,
.section-title h2::after {
  content: "";
  width: 50px;
  height: 2px;
  background: #3498db;
  display: inline-block;
}

.section-title h2::before {
  margin: 0 15px 10px 0;
}

.section-title h2::after {
  margin: 0 0 10px 15px;
}

.section-title p {
  margin: 15px 0 0 0;
}

/* Fixing style */
.icon-box:before {
    content: none;
}

/*--------------------------------------------------------------
# Testimonials
--------------------------------------------------------------*/
.testimonials .testimonials-carousel,
.testimonials .testimonials-slider {
  overflow: hidden;
}

.testimonials .testimonial-item {
  box-sizing: content-box;
  min-height: 320px;
}

.testimonials .testimonial-item .testimonial-img {
  width: 90px;
  border-radius: 50%;
  margin: -40px 0 0 40px;
  position: relative;
  z-index: 2;
  border: 6px solid #fff;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
}

.testimonials .testimonial-item h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 5px 45px;
  color: #2c4964;
}

.testimonials .testimonial-item h4 {
  font-size: 14px;
  color: #999;
  margin: 0 0 0 45px;
}

.testimonials .testimonial-item .quote-icon-left,
.testimonials .testimonial-item .quote-icon-right {
  color: #b1a9fc;
  font-size: 26px;
}

.testimonials .testimonial-item .quote-icon-left {
  display: inline-block;
  left: -5px;
  position: relative;
}

.testimonials .testimonial-item .quote-icon-right {
  display: inline-block;
  right: -5px;
  position: relative;
  top: 10px;
}

.testimonials .testimonial-item .desc {
  margin: 0 15px 0 15px;
  padding: 20px 55px 60px 55px;
  line-height: 1.6;
  background: #fff;
  position: relative;
  border-radius: 6px;
  position: relative;
  z-index: 1;
  box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.1);
}

.testimonials .testimonial-item .desc p{
  font-style: italic;
  font-size: 24px;
  line-height: 1.6;
text-align: justify;
  text-justify: inter-word;
}

.testimonials .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.testimonials .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 1;
  border: 1px solid #5846f9;
}

.testimonials .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #5846f9;
}

@media (max-width: 767px) {
  .testimonials {
    margin: 30px 10px;
  }
}
</style>
